import {DigitalPageItem} from '../../../interfaces/digital-page-item';
import {ProductTypeEnum} from '../../../interfaces/product-type-enum';

export const DigitalProductPageItem: DigitalPageItem = {
  ProductType: ProductTypeEnum.Sample,
  Title: 'Hello!',
  ProductCode: 'paq43',
  Description:
    '<p>Try some of the online revision included with our Physics Exam Practice Workbooks. Get full access to all the features when you <a href="[[external_domain]]/info/new-gcse-aqa-science-books" class="link-button"  class="link-button" style="color: #1494D4"><strong>buy your book</strong></a> and unlock CGP RevisionHub with the unique code printed inside!</p>\n'
    ,
    // +
    // '\n' +
    // '<p>Want to try another subject? Check&nbsp;out the&nbsp;CGP RevisionHub for&nbsp;<a href="/samples/baq43"  class="link-button" style="color: #1494D4"><strong>Biology</strong></a>&nbsp;and&nbsp;<a href="/samples/caq43"  class="link-button" style="color: #1494D4"><strong>Chemistry</strong></a>.</p>\n'
  Credits:
    '<p><i>Text, design, layout and original illustrations &copy; Coordination Group Publications Ltd. (CGP) 2025.&nbsp; All rights reserved.</i></p>',
  FreeSampleContent:
    '<p>This is a free sample of the CGP RevisionHub for our GCSE Physics Exam Practice Workbooks. <a href="[[external_domain]]/info/new-gcse-aqa-science-books" class="link-button" style="color: #FF9335;">Order</a> your book now for full access to online Physics revision.</p>',
};
